export const parseQueryParamInt = (value: string | null, options: { fallback: number; min?: number; max?: number }) => {
  const parsed = value ? Number.parseInt(value, 10) : Number.NaN;
  const fallbackValue = options.fallback;

  if (!Number.isFinite(parsed)) {
    return fallbackValue;
  }

  if (options.min !== undefined && parsed < options.min) {
    return options.min;
  }
  if (options.max !== undefined && parsed > options.max) {
    return options.max;
  }

  return parsed;
};
